import { render } from "./AlertDestinationsBatch.vue?vue&type=template&id=f52d154a"
import script from "./AlertDestinationsBatch.vue?vue&type=script&lang=js"
export * from "./AlertDestinationsBatch.vue?vue&type=script&lang=js"

import exportComponent from "/Users/linuxbasic/GitProjects/caru-platform-api/systems/caru-cloud-platform/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__